const ini = require('ini');

/**
 * Parse a .ini file and return its contents as an object.
 *
 * @param {string} iniString
 */
const parseIni = (iniString) => {
    if (typeof iniString !== 'string' || iniString.length < 1) {
        return {};
    }

    iniString = iniString.trim();
    if (!iniString) {
        return {};
    }

    return ini.parse(iniString);
};

/**
 * Parses the ini file at the given path and returns an array of lang keys found in the file.
 * Each value returned is an array of strings,
 * where the first string is the section name and the second string is the key name.
 *
 * @param {string} iniString
 *
 * @returns {[string, string][]}
 */
const extractKeysFromIniFile = (iniString) => {
    const parsed = parseIni(iniString);

    const entries = [];
    for (let section in parsed) {
        if (typeof parsed[section] === 'string') {
            entries.push([null, section]);
        } else {
            // eslint-disable-next-line guard-for-in
            for (let key in parsed[section]) {
                entries.push([section, key]);
            }
        }
    }

    return entries;
};

module.exports = {
    extractKeysFromIniFile,
    parseIni,
};
